import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    CodigoConfeccionItemResultsViewModel,
    CodigoConfeccionItemViewModel,
    CodigoConfeccionViewModel,
    FilterSearchingCodigoConfeccionViewModel,
} from './codigoconfeccion.types';
import { RecintoPIAEdListViewModel } from 'src/app/components/_campanias/recintos/recinto.types';

@Injectable()
export class CodigoConfeccionService {
    private lastSearch?: FilterSearchingCodigoConfeccionViewModel;
    private endpointAlmacen = this.baseUrl + 'api/mantenimiento/codigoconfeccion';
    private arrBooleanKeys = ['Activo', 'Autorizado'];

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterSearchingCodigoConfeccionViewModel
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterSearchingCodigoConfeccionViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingCodigoConfeccionViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (this.arrBooleanKeys.indexOf(k) !== -1 && valor == 0) {
                v = 0;
            } else {
                v = payload[k] || '';
            }

            params = params.append(k, v);
        }

        return params;
    }

    getCodigoConfeccionPagedByFilter(payload: FilterSearchingCodigoConfeccionViewModel): Observable<CodigoConfeccionItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);

        return this.http.get<CodigoConfeccionItemResultsViewModel>(this.endpointAlmacen + '/pagedbyfilter/', { params: params }).pipe();
    }

    getCodigoConfeccion(id: number): Observable<CodigoConfeccionViewModel> {
        return this.http.get<CodigoConfeccionViewModel>(this.endpointAlmacen + '/' + id).pipe();
    }

    edit(destinocodigoconfeccion: CodigoConfeccionViewModel): Observable<any> {
        return this.http.put<CodigoConfeccionViewModel>(this.endpointAlmacen, destinocodigoconfeccion).pipe();
    }

    create(codigo: CodigoConfeccionViewModel): Observable<any> {
        return this.http.post<CodigoConfeccionViewModel>(this.endpointAlmacen, codigo).pipe();
    }

    delete(id: number): Observable<any> {
        return this.http.delete<CodigoConfeccionViewModel>(this.endpointAlmacen + '/' + id).pipe();
    }

    authorize(id: number): Observable<any> {
        return this.http.put<CodigoConfeccionViewModel>(this.endpointAlmacen + '/authorize', id);
    }

    export(model: FilterSearchingCodigoConfeccionViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.endpointAlmacen + '/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' }).pipe();
    }

    getLastSearch(): FilterSearchingCodigoConfeccionViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    getAlmacenesByList(payload: RecintoPIAEdListViewModel): Observable<CodigoConfeccionItemResultsViewModel> {
        return this.http.post<any>(this.endpointAlmacen + '/getAlmacenesByList/', payload);
    }

    getAlmacenesAutorizadosByList(IdPeriodoCam: number): Observable<CodigoConfeccionItemViewModel[]> {
        return this.http.get<any>(this.endpointAlmacen + '/GetAlmacenesAutorizados/' + IdPeriodoCam);
    }

    getAlmacenesAceptadosByIdPeriodo(IdPeriodoCam: number, IdCampania: number): Observable<CodigoConfeccionItemViewModel[]> {
        return this.http.get<any>(this.endpointAlmacen + '/GetAlmacenesAceptados/' + IdPeriodoCam + '/' + IdCampania);
    }
}
